<template>
  <div>
    <EChart
      v-if="showChart && $route.query.tab == 'salaryInformation'"
      :chartId="'turnover'"
      :optionChart="optionChartSalaryData"
      :heightChart="'580'"
    />
    <div class="no-data" v-if="noneData">
      <h3>Không có dữ liệu</h3>
    </div>
  </div>
</template>
<script>

import MethodService from '../../../../service/MethodService'
import DataService from '../../../../service/DataService'
import SalaryApi from '@/moduleApi/SalaryApi'
import EChart from '../../../../component/EChart/EChart'
import EventBus from "@/service/EventBus"
export default {
  components: {
    EChart,
  },
  props: {
    fromPeriodProp: {
      type: String,
      default: undefined
    },
    toPeriodProp: {
      type: String,
      default: undefined
    },
    listSalaryPeriod: {
      type: Array,
      default: (() => [])
    },
    haveSalaryPeriod: {
      type: Boolean,
      default: true
    },
    keySubmit: {
      type: String,
      default: undefined
    },
  },
  data() {
    return {
      MethodService,
      flag: undefined,
      newData: false,
      showChart: true,
      noneData: false,
      listColors: DataService.listColors,
      optionChartSalaryData: {}
    }
  },
  watch: {
    keySubmit(newVal) {
      if (this.$route.query.tab && this.$route.query.tab == 'salaryInformation') {
        this.showChart = false
        setTimeout(() => {
          this.getDataChart()
        }, 500)
      }
    },
    haveSalaryPeriod(newVal) {
      console.log('newVal', newVal);
      this.noneData = true
    },
  },
  methods: {
   // This function is used to get data from the API and change the data to the data that can be used
   // to draw the chart.
    async getDataChart(){
      if (this.flag || this.fromPeriodProp == 'default' || this.toPeriodProp == 'default') return
      this.flag = 1
      let data = {
        from_date: this.getStartTimePeriod(this.fromPeriodProp),
        to_date: this.getEndTimePeriod(this.toPeriodProp)
      }
      const getEmployeeSalariesApiRes = await SalaryApi.GetEmployeeSalaries(data)
      const resData = this.changeData(getEmployeeSalariesApiRes.result)
      let dataLabel = []
      let dataSeries = []
      if (resData.length == 0) {
        this.noneData = true
      } else {
        this.noneData = false
      }
      resData.forEach((e,i) => {
        dataLabel.push(e.name_period)
        e.arrFields.forEach((x,z) => {
          let checkExistKey = dataSeries.find(y => y.name == x.key)
          if (!checkExistKey) {
            let obj = {
              name: x.key,
              type: 'bar',
              emphasis: {
                focus: 'series'
              },
              data: [],
              color: this.listColors[z]
            }
            for (let y = 0; y < resData.length; y++) {
              obj.data[y] = 0
            }
            obj.data[i] = parseInt(x.value)
            dataSeries.push(obj)
          } else {
            checkExistKey.data[i] = parseInt(x.value)
          }
        })
      })
      this.setDataChart(dataLabel, dataSeries)
      setTimeout(() => {
        this.flag = undefined
      }, 1000)
    },
    // A function to change the data from the API to the data that can be used to draw the chart.
    changeData(data) {
      let resData = []
      data.forEach(item => {
        // if (item.custom_fields.length < 18) return
        let newObj = {}
        newObj.start_time = this.getStartTimePeriod(item.salary_period_id)
        newObj.name_period = this.changeNameSalaryPeriodToMMYYYY(this.getStartTimePeriod(item.salary_period_id))
        newObj.arrFields = []
        item.custom_fields.forEach(field => {
          if (!isNaN(field.value)) {
            newObj.arrFields.push(field)
          }
        })
        resData.push(newObj)
      })
      resData.sort((a,b) => {
        return new Date(a.start_time).getTime() - new Date(b.start_time).getTime()
      })
      return resData
    },
    // A function to set data for chart.
    setDataChart(dataLabel, dataSeries) {
      this.showChart = false
      this.optionChartSalaryData = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          orient: 'vertical',
          right: 1,
          top: 'center'
        },
        grid: {
          left: '2%',
          right: '23%',
          bottom: '2%',
          top: '5%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              alignWithLabel: true
            },
            data: dataLabel,
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: 'Đơn vị: VNĐ'
          }
        ],
        series: dataSeries
      }
      setTimeout(() => {
        this.showChart = true
      }, 500)
    },
    // A function to change the name of the period to the format MM/YYYY.
    changeNameSalaryPeriodToMMYYYY(name) {
      let month = new Date(name).getMonth() + 1
      let year = new Date(name).getFullYear()
      return `${month < 10 ? '0' + month : month}/${year}`
    },
    // A function to get the start time of a period.
    getStartTimePeriod(id) {
      let period = this.listSalaryPeriod.find(e => e.id == id)
      return period && period.from_date ? period.from_date : undefined
    },
    // A function to get the end time of a period.
    getEndTimePeriod(id) {
      let period = this.listSalaryPeriod.find(e => e.id == id)
      return period && period.before_to_date ? period.before_to_date : undefined
    },
  },
  created() {
    EventBus.$off('changeSizeMenuSalary')
    EventBus.$on('changeSizeMenuSalary', () => {
      this.showChart = false
      setTimeout(() => {
        this.showChart = true
      }, 50)
    })
  },
}
</script>

<style lang="scss" scoped>
.no-data {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
